/**
 * v0.4 追加要件⑪ (D-355/D-365): シフトレポート系画面 (`/shift/report/daily`・`/shift/report/employees`)
 * が共有する日付ユーティリティ。バックエンドの半開区間 [from, to) の意味論と一致させる。
 * 2画面で個別定義すると片方だけ変更して食い違う §8-93 型の事故になるため1箇所に集約する
 * (design-and-code M-3)。
 */
export const todayIso = (): string => new Date().toISOString().slice(0, 10);
export const thisMonthStart = (): string => `${todayIso().slice(0, 7)}-01`;
export const nextMonthStart = (fromMonthStart: string): string => {
  const d = new Date(`${fromMonthStart}T00:00:00Z`);
  d.setUTCMonth(d.getUTCMonth() + 1);
  return d.toISOString().slice(0, 10);
};
export const addDaysIso = (date: string, delta: number): string => {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + delta);
  return d.toISOString().slice(0, 10);
};
/** [from, to) の半開区間を暦日配列にする (バックエンドと同じ意味論) */
export const enumerateDates = (from: string, to: string): string[] => {
  const out: string[] = [];
  let cur = from;
  while (cur < to) { out.push(cur); cur = addDaysIso(cur, 1); }
  return out;
};
